var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3570_13217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0683 0.0381336C17.0202 -0.0132605 16.9373 -0.0132605 16.8875 0.0381336L7.57194 9.35374C7.52386 9.40182 7.44428 9.40182 7.3962 9.35374L3.18354 5.14274C3.15867 5.11787 3.12054 5.11787 3.09567 5.14274L0.0186511 8.21975C-0.00621704 8.24462 -0.00621704 8.28275 0.0186511 8.30762L7.3962 15.6852C7.44428 15.7332 7.52386 15.7332 7.57194 15.6852L16.9804 6.27672C18.6979 4.55916 18.7278 1.79217 17.0699 0.0381336H17.0683Z",
    fill: "#5B836D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48293 6.78403C8.96532 6.78403 10.167 5.58231 10.167 4.09993C10.167 2.61754 8.96532 1.41582 7.48293 1.41582C6.00054 1.41582 4.79883 2.61754 4.79883 4.09993C4.79883 5.58231 6.00054 6.78403 7.48293 6.78403Z",
    fill: "#5B836D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3570_13217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.2897,
    height: 15.7216,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.5cdcb5fd404030b9a07b85c8cf091990.svg";
export { ForwardRef as ReactComponent };